const SPACEBAR = 32;

const validRoleRegex = /^(checkbox|radio|button)$/;

const handleKeyDown = event => {
  if (event.keyCode !== SPACEBAR) {
    return;
  }

  const role = event.target.getAttribute('role');

  if (!role || !validRoleRegex.test(role)) {
    return;
  }

  event.preventDefault();
  event.target.click();
};

const attach = target => {
  target.addEventListener('keydown', handleKeyDown);
};

export default attach;



/** WEBPACK FOOTER **
 ** ./app/wip_modules/aria-click/index.js
 **/